var React = require('react');

function Hockey (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 8C4.60719 11.3928 1.94478 15.9448 3.69345 17.6934L7.00846 21.0085C8.66596 22.666 12.9191 20.8991 16.9091 16.9091C20.8991 12.9191 22.666 8.66596 21.0085 7.00846L17.6934 3.69344C15.9448 1.94478 11.3928 4.60719 8 8ZM8.82875 8.82875C12.6241 5.03344 16.0394 3.78942 16.8184 4.56845C17.5975 5.34747 16.3535 8.76283 12.5581 12.5581C8.76283 16.3535 5.34747 17.5975 4.56845 16.8184C3.78942 16.0394 5.03344 12.6241 8.82875 8.82875ZM16.0803 16.0803C12.471 19.6897 8.86346 21.1135 7.88346 20.1335L5.92346 18.1735C8.07517 17.7746 11.0135 15.7603 13.3869 13.3869C15.7603 11.0135 17.7745 8.07518 18.1735 5.92346L20.1335 7.88346C21.1135 8.86346 19.6897 12.471 16.0803 16.0803Z","fill":"white"}));
}

Hockey.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Hockey;

Hockey.default = Hockey;
